export enum UserBundleMappingStatus {
    PENDING = "PENDING",
    ACTIVE = "ACTIVE",
    UPCOMING = "UPCOMING",
    FULFILLED = "FULFILLED",
    CLOSED = "CLOSED",
    CANCELLED = "CANCELLED"
}